module.exports = __webpack_public_path__ + "static/img/3-6.8.5.3fc89ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/3-6.8.5.png
// module id = ZhET
// module chunks = 0